if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          // Get current selected values as strings (by option position)
          const selectedValues = Array.from(
            this.querySelectorAll('[data-option-position]')
          )
            .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
            .map((fieldset) => {
              const checked = fieldset.querySelector('input:checked, select');
              return checked?.tagName === 'SELECT' ? checked.value : checked?.value;
            });

          this.updateOptionAvailability(target, selectedValues); // synchronous, no blink

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
      
      get productVariants() {
        const el = this.querySelector('[data-product-variants]');
        return el ? JSON.parse(el.innerHTML) : [];
      }

      updateOptionAvailability(changedOptionPosition, selectedValues) {
        this.querySelectorAll('[data-option-variant-map]').forEach((mapEl) => {
          const position = parseInt(mapEl.dataset.optionPosition); // 1-based
          const variantMap = JSON.parse(mapEl.innerHTML);
          const fieldset = mapEl.closest('[data-option-position]');
          if (!fieldset) return;

          fieldset.querySelectorAll('input[type="radio"], select option').forEach((input) => {
            const value = input.value;
            const variantIds = variantMap[value] || [];

            // Check if any variant with this value is available given the other selected options
            const isAvailable = variantIds.some((id) => {
              const variant = this.productVariants.find((v) => v.id === id);
              if (!variant) return false;

              // All other positions must match current selections
              return variant.options.every((optVal, i) => {
                if (i === position - 1) return true; // skip self
                return selectedValues[i] === optVal;
              });
            });

            const isSoldOut = variantIds.every((id) => {
              const variant = this.productVariants.find((v) => v.id === id);
              if (!variant) return true;
              return !variant.available && variant.options.every((optVal, i) => {
                if (i === position - 1) return true;
                return selectedValues[i] === optVal;
              });
            });

            input.dataset.available = isAvailable && !isSoldOut ? 'true' : 'false';

            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.toggle('variant--unavailable', !isAvailable);
              label.classList.toggle('variant--sold-out', isAvailable && isSoldOut);
            }
          });
        });
      }
    }
  );
}
